module.exports = __webpack_public_path__ + "static/media/id_image.9941de49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id_image.png
// module id = 745
// module chunks = 0